module.exports = __webpack_public_path__ + "img/pcx-bg.691671b7.svg";